module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    attrs: {
      "title": _vm.isEditFeedback ?
        'Edit Saved Feedback Template' :
        'New Saved Feedback Template',
      "disableOutsideClick": true,
      "size": 'sm'
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('body', {
    staticClass: "center items-center p-5 flex-grow"
  }, [_c('textbox', {
    staticClass: "feedback-input center",
    attrs: {
      "rows": "2",
      "maxHeight": 100,
      "maxLength": 200,
      "placeholder": "",
      "showSubmitButton": false,
      "fillRemaining": true,
      "keepFocus": Boolean(_vm.feedback_content),
      "data-gramm": "false"
    },
    model: {
      value: (_vm.feedback_content),
      callback: function($$v) {
        _vm.feedback_content = $$v
      },
      expression: "feedback_content"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "flex my-5 center items-center"
  }, [_c('button', {
    staticClass: "mx-5 px-10 py-2 w-40 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.submitFeedback
    }
  }, [_vm._v("\n        Create\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-56ebfd6d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/savedFeedbackModal.vue
// module id = 1070
// module chunks = 61